import { cn } from "@nexus/ui";
import { orgInitials } from "@/features/identity-hub/utils/iam.utils";

interface SuperTenantOrgAvatarProps {
  name: string;
  size?: number;
  className?: string;
  textClassName?: string;
}

/**
 * Animated initials avatar for SUPER_TENANT orgs (e.g. Adge).
 * Slow gradient shift + shimmer — disabled under prefers-reduced-motion.
 */
export function SuperTenantOrgAvatar({
  name,
  size = 36,
  className,
  textClassName,
}: SuperTenantOrgAvatarProps) {
  return (
    <span
      className={cn(
        "iam-super-tenant-avatar relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg font-bold text-white",
        "shadow-[inset_0_1px_0_0_rgba(255,255,255,0.22),0_0_0_1px_rgba(255,255,255,0.08)]",
        className,
      )}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.42,
      }}
    >
      <span className={cn("relative z-[1] drop-shadow-sm", textClassName)}>
        {orgInitials(name)}
      </span>
    </span>
  );
}
